import qs from 'query-string'

import { getBaseUrl } from '@/utils/url'

/**
 * Returns the most representative form of the current URL to avoid indexation duplication
 */
export const getPageCanonicalUrl = (asPath: string) => {
  const baseUrl = getBaseUrl()

  /**
   * The canonical url should be the same as the current url without the query parameters
   * */
  const { url } = qs.parseUrl(`${baseUrl}${asPath}`)

  return url
}
